export default __webpack_public_path__ + "static/media/330_dummy2016-modelportfolio01-de.eb8a03ee.png";